import type { CoreExpression, UnaryExpression } from 'jsep';
import { ExpressionReturnType } from '../expressions/common';

export interface Expression {
  type: ExpressionReturnType;
  ast: CoreExpression;
}

export const expressionScopeRequestEvent = 'expression-scope-request';

export interface ExpressionScopeRequestPayload {
  identifiers: Record<string, ExpressionReturnType>;
}

export type ExpressionValidationResult =
  | { valid: true; type: ExpressionReturnType }
  | { valid: false; reason: string };

export function negateExpression(expr: CoreExpression): CoreExpression {
  if (expr.type === 'UnaryExpression' && expr.operator === '!') {
    return expr.argument as CoreExpression;
  }
  const negated: UnaryExpression = {
    type: 'UnaryExpression',
    operator: '!',
    argument: expr,
    prefix: true
  };
  return negated;
}
